import "./style.scss";
import Header from "../SharedComponents/Header";
import Navbar from "../SharedComponents/Navbar";
import { ReactComponent as ShareIcon } from "../assets/icons/shareIcon.svg";
import { ReactComponent as FileIcon } from "../assets/icons/fileIcon.svg";
import { ReactComponent as Facebook } from "../assets/icons/facebook.svg";
import { ReactComponent as Youtube } from "../assets/icons/youtube.svg";
import { ReactComponent as LinkedIn } from "../assets/icons/linkedIn.svg";
import { ReactComponent as GooglePuls } from "../assets/icons/g+.svg";
import { ReactComponent as Website } from "../assets/icons/website.svg";
import { ReactComponent as Instagram } from "../assets/icons/instagram.svg";
import { ReactComponent as Twitter } from "../assets/icons/twitter.svg";
import Score from "../SharedComponents/Score";
import { useParams, useNavigate } from "react-router-dom";
import ButtonPrimary from "../SharedComponents/ButtonPrimary";
import { useTranslation } from "react-i18next";
import { host, produceLink } from "../universalData";
import { useState, useContext, useReducer, useRef } from "react";
import { postAjax } from "../axiosMethods";
import Store from "../Store";
import { copyToClipboard } from "../helperFunctions";
import { ClipLoader } from "react-spinners";
import GlobalStates from "../../layouts/GlobalStates";
import { GlobalStateContext } from "./../../layouts/GlobalStates";
import ButtonSecondary from "./../SharedComponents/ButtonSecondary/index";
import { DBButton } from "./../../DBComponents/DBButton/index";
import DBTextArea from "./../../component/global/DBTextArea/index";
import {
    RewardBadge,
    RewardStatus,
} from "../../features/incentives/Rewards";

export default function ShareProduct() {
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;
    const [loader1, setLoader1] = useState(false);
    const [loader2, setLoader2] = useState(false);
    const [description, setDescription] = useState();
    const [url, setUrl] = useState("");
    const [copied, setCopied] = useState(false);
    const { id } = useParams();
    const urlText = useRef();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const produceLinkHandle = (type) => {
        if (type === 2) {
            setLoader2(true);
        } else {
            setLoader1(true);
        }
        postAjax(produceLink, {
            item: result.data.item,
            item_qr_code: result.productId,
            user: result.username || window.sessionStorage.getItem("username"),
            description,
        })
            .then((e) => {
                console.log(e);
                setUrl(
                    process.env.REACT_APP_WEBSITE +
                        "/pwa/feedback/" +
                        id +
                        "/share/" +
                        e.code
                );
                if (type === 2) {
                    copyClipboardHandle(
                        process.env.REACT_APP_WEBSITE +
                            "/pwa/feedback/" +
                            id +
                            "/share/" +
                            e.code
                    );
                } else {
                    fireShare(
                        process.env.REACT_APP_WEBSITE +
                            "/pwa/feedback/" +
                            id +
                            "/share/" +
                            e.code
                    );
                }
            })
            .finally((_) => {
                setLoader1(false);
                setLoader2(false);
            });
    };
    const message =
        t("copy.share.link").replace("*", "*" + result.ajax.item.name + "*") +
        "\n\n" +
        t("start.rating.thanks") +
        "\n" +
        t("start.rating.didban") +
        "\n\n";

    const fireShare = (code) => {
        const shareData = {
            text: message + code,
        };
        navigator.share(shareData);
    };

    const copyClipboardHandle = (code) => {
        urlText.current?.select();

        copyToClipboard(message + code);
        setCopied(true);
        setTimeout((_) => setCopied(false), 1000);
    };

    return (
        <div className="main-container">
            <div className="participation-reward-row">
                <RewardBadge
                    action="introduction"
                    targetType="item"
                    targetId={result.data.item}
                    opportunity={
                        result.ajax?.incentive_opportunities?.introduction
                    }
                />
            </div>
            <p className="share-reward-hint">{t("share.msg.detail")}</p>
            {url && (
                <RewardStatus
                    action="introduction"
                    targetType="item"
                    targetId={result.data.item}
                />
            )}
            {sessionStorage.getItem("username") || result.username ? (
                <>
                    <div className="share-product">
                        <p>{t("share.msg")}</p>
                        <h2>{t("about.product")}</h2>
                        <DBTextArea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder={t("share.hint")}
                        />
                        <div className="share-btn-con">
                            <DBButton
                                loading={loader1}
                                onClick={() => produceLinkHandle(1)}
                                disabled={loader1 || loader2 || !description}
                            >
                                {t("produce.link.share")}
                            </DBButton>
                            <DBButton
                                loading={loader2}
                                disabled={loader1 || loader2 || !description}
                                outlined={true}
                                onClick={() => produceLinkHandle(2)}
                            >
                                {t("produce.link")}
                            </DBButton>
                        </div>
                        {/* <h2>{t("link")}</h2>
                        <div
                            className="input-section"
                            onClick={(_) => copyClipboardHandle(url)}
                        >
                            <button>
                                <ShareIcon />
                            </button>
                            <input
                                type="text"
                                readOnly
                                value={url}
                                ref={urlText}
                                dir="ltr"
                            />
                            <button>
                                <FileIcon />
                            </button>
                        </div> */}
                        {/* <div className="social-group">
                            <button>
                                <Website />
                            </button>
                            <button>
                                <LinkedIn />
                            </button>
                            <button>
                                <GooglePuls />
                            </button>
                            <button>
                                <Youtube />
                            </button>
                            <button>
                                <Instagram />
                            </button>
                            <button>
                                <Twitter />
                            </button>
                            <button>
                                <Facebook />
                            </button>
                        </div> */}

                        {/* <Score size="big" score={4} title={true}/> */}
                    </div>
                    <div
                        className={
                            "floating-notification" + (copied ? " show" : "")
                        }
                    >
                        {t("copied")}
                    </div>
                </>
            ) : (
                <div className="share-product no-access">
                    {t("more.no.access")}
                    <div>
                        <ButtonPrimary
                            btnContent={t("send.Feedback.label")}
                            onClick={() => navigate("/feedback/form/" + id)}
                        />
                        <ButtonSecondary
                            btnContent={
                                t("LogIn.Button") + " / " + t("SignUp.Tab")
                            }
                            onClick={() =>
                                navigate("/auth", {
                                    state: {
                                        from: `/feedback/share-product/${id}`,
                                    },
                                })
                            }
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
